import { PropsWithChildren, useCallback, useMemo } from "react"

import { AuthContext } from "context/AuthContext"

import { useLocalStorage } from "hooks/"

export const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [token, setToken] = useLocalStorage<string | undefined>(
    "token",
    undefined
  )
  const [adb2cToken, setAdb2cToken] = useLocalStorage<string | undefined>(
    "adb2cToken",
    undefined
  )

  const unsetTokens = useCallback(() => {
    setToken(undefined)
    setAdb2cToken(undefined)
  }, [setToken, setAdb2cToken])

  const contextValue = useMemo(
    () => ({ token, setToken, adb2cToken, setAdb2cToken, unsetTokens }),
    [token, setToken, adb2cToken, setAdb2cToken, unsetTokens]
  )

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  )
}
